<template>
  <ProductPage />
</template>

<script>
import ProductPage from "@/components/ProductPages";
export default {
  name: "Ourproducts",

  components: {
    ProductPage,
  },
};
</script>

<style></style>
